module.exports = __webpack_public_path__ + "img/bag1.ebbd8c70.jpg";